<template lang="pug">
  div
    v-row
      v-col(cols="12", md="10", offset-md="1")
        User(:update='true', :username='$route.params.username')
</template>

<script>
import User from '@/components/User.vue';

export default {
  components: {
    User
  }
};
</script>

<style>
</style>
